<template>
    <el-dropdown placement="bottom" trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
            <img v-if="currentCountry.flag" :src="currentCountry.flag" :alt="currentCountry.code">
            <span>+{{ value }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="country in countries" :key="country.code" :class="{
                'is-selected': country.callingCode === value
            }" :command="country">
                <img :src="country.flag" :alt="country.code">
                <span>+{{ country.callingCode }}</span>
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
import countries from './countries';

export default {
  name: 'country-calling-code-picker',
  model: {
    event: 'change',
  },

  props: {
    value: {
      type: Number,
      default: 86,
    },
  },

  data() {
    return {
      countries,
      currentCountry: {},
    };
  },

  methods: {
    handleCommand(country) {
      this.currentCountry = country;
      this.$emit('change', country.callingCode, this.value);
    },
  },

  created() {
    countries.forEach((country) => {
      if (country.callingCode === this.value) {
        this.currentCountry = country;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
  .el-dropdown {
    height: 32px;
    margin-left: -21px;
    margin-right: -21px;
    width: 90px;

    &-link {
      align-items: center;
      display: flex;
      height: inherit;
      padding-left: 12px;
      padding-right: 12px;

      > img {
        margin-right: 8px;
        width: 16px;
      }
    }

    &-menu {
      width: 90px;

      &__item {
        align-items: center;
        display: flex;
        padding-left: 12px;
        padding-right: 12px;

        &.is-selected {
          background-color: #e9f0f7;
          color: #515152;
        }

        > img {
          margin-right: 8px;
          width: 16px;
        }
      }
    }
  }
</style>
